import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const getStyle = (style) => {
  return _.assign({
    padding: 3,
    fontSize: 12,
    color: 'white',
    backgroundColor: 'green',
    textTransform: 'uppercase',
  }, style);
};

class Status extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    containerStyle: PropTypes.object,
  }

  render() {
    const { containerStyle } = this.props;
    return (
        <span style={getStyle(containerStyle)}>{this.props.label}</span>
    );
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/components/Common/Status/index.js